import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { IResponse } from "@app/lib/models/response.model";
import { IHearCaseSearchFormData, IHearingSaveParams, IHearingSchedule, IHearingScheduleCourtRoom, IHearingScheduleParams, IJusticePanel } from "../models/hearing-schedule";
import { ICourtSessionPanel, ICourtSessionPanelParams, IPagination, ISearchRequestParams } from "../models/case-assignment.model";
import { ILoginData } from "@app/lib/models/login.model";
import { TAny, TIdName } from "@app/lib/models/common.type";

@Injectable({
    providedIn: 'root'
})
export class HearingScheduleService extends BaseHttpService {

    constructor(
        http: HttpClient,
        appConfig: AppConfiguration,
    ) {
        super(http, appConfig);
    }

    getHearingTailCourts(reqBody: IHearingScheduleParams, queryParams: ISearchRequestParams) {
        const courtData: ILoginData | null = this.getCourtNameData();

        if (courtData && (courtData.courtId === 2 || courtData.courtId === 1)) {
            return this.post<IResponse<IHearingSchedule[]>, IHearingScheduleParams>(
                'hearing-schedule/search/appeal-hearing.htm',
                reqBody,
                { params: { ...queryParams } }
            );
        } else {

            return this.post<IResponse<IHearingSchedule[]>, IHearingScheduleParams>(
                'hearing-schedule/cases/trail-courts/todo.htm',
                reqBody,
                { params: { ...queryParams } }
            );
        }
    }


    getCourtNameData(): ILoginData | null {
        try {
            const userData = localStorage.getItem('userData');
            return userData ? JSON.parse(userData) : null;
        } catch (err) {
            return null;
        }
    }

    assignHearingDateForCourt(reqBody: TAny) {
        return this.post<IResponse<any>, any>('hearing-schedule/assign/hearing-date.htm', [reqBody]);
    }
    assignHearingDateForAppeal(reqBody: TAny) {
        return this.post<IResponse<any>, any>('hearing-schedule/assign/appeal/hearing-date.htm', [reqBody]);
    }
    cancelHearingDate(reqBody: TAny) {
        return this.post<IResponse<any>, any>('reschedule-hearing/reschedule.htm', reqBody);
    };
    getCourtSessions(queryParams: IPagination) {
        return this.get<IResponse<TIdName[]>>('court-panel/court/session.htm', { params: { ...queryParams } });
    }

    getPanels(queryParams: ICourtSessionPanelParams) {
        return this.get<IResponse<ICourtSessionPanel[]>>('court-panel/court/session/panels.htm', { params: { ...queryParams } });
    }
    getCourtRoom(queryParams: TAny) {
        return this.get<IResponse<IHearingScheduleCourtRoom[]>>('court-unit-types/fetch/courts-division/hearing-date.htm', { params: { ...queryParams } });
    }

    fetchOriginalJusticePanel(reqBody: TAny) {
        return this.post<IResponse<IJusticePanel[]>, any>('hearing-schedule/fetch/standard/panel-justices.htm', reqBody);
    }
    fetchChangedJusticePanel(reqBody: TAny) {
        return this.post<IResponse<IJusticePanel[]>, any>('hearing-schedule/fetch/case/panel-justices.htm', reqBody);
    }

    getJudgementdataSearch(reqBody: TAny, queryParams: ISearchRequestParams) {

        return this.post<IResponse<TAny>, TAny>(
            'judgementDate/search.htm',
            reqBody,
            { params: { ...queryParams } }
        );
    }
    assignJudgementDate(reqBody: TAny) {
        return this.post<IResponse<any>, any>('judgementDate/fix-date.htm', reqBody);
    }
}